import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import { getPrice, getSlotsByOrder } from '../../../smoothr-web-app-core/utils/utils';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { IonContent, ModalController, PickerController } from '@ionic/angular';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import * as moment from 'moment';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { TosPage } from '../../pages/tos/tos.page';
import { PrivacyPage } from '../../pages/privacy/privacy.page';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Moment } from 'moment';
import { ValidationUtils } from '../../../smoothr-web-app-core/utils/validation-utils';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { Router } from '@angular/router';
import { calculateGeoDistance, MapsUtils } from '../../../smoothr-web-app-core/utils/maps-utils';
import { isVenueOpen, numberToCurrency } from '../../../smoothr-web-app-core/utils/utils';
import Order from '../../../smoothr-web-app-core/models/Order';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { TimeUtils } from '../../../smoothr-web-app-core/utils/time-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import { environment } from 'src/environments/environment';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { countries } from '../input-phone-with-county-code/mock-countries';
import { Api } from '../../../smoothr-web-app-core/api/api';
import { BeforeCreateOrderSelectTimeDialogComponent } from '../before-create-order-select-time-dialog/before-create-order-select-time-dialog.component';
import { AddGiftCardDialogComponent } from '../loyalty-components/add-gift-card-dialog/add-gift-card-dialog.component';

@Component({
	selector: 'app-checkout-modal',
	templateUrl: './checkout-modal.component.html',
	styleUrls: ['checkout-modal.component.scss'],
})
export class CheckoutModalComponent extends RepositoryDirective implements OnInit {
	orderUtils = OrderUtils;
	loading = false;
	now: moment.Moment;
	pt = PreorderType;
	nameError: string;
	emailError: string;
	phoneError: string;
	streetNumberError: string;
	orderAtError: string;
	streetError: string;
	postalCodeError: string;
	hadPostalCode = false;
	telCountryOptions: any = {
		cssClass: 'tel-country-popover',
	};
	isVenueOpen = false;
	tip: number = 0;
	orderForm: FormGroup;
	name = 'name';
	surname = 'surname';
	email = 'email';
	phone = 'phone';
	note = 'note';
	orderAt = 'orderAt';
	agb = 'agb';
	isLargeScreen = AppComponent.largeScreen;
	numberToCurrency = numberToCurrency;
	slots: Moment[] = [];
	environment = environment;

	@ViewChild(IonContent, { static: false }) content;
	@ViewChild('swiperCheckout', { static: false }) slides;
	slideOptions = {
		spaceBetween: 0,
		initialSlide: 0,
		speed: 400,
		allowTouchMove: false,
	};
	isOverviewPage = false;
	@Output() closedDialog = new EventEmitter<void>();

	totalPriceValue: string = '';
	companyDisount = '';
	calculateTaxesLoading = false;
	totalPriceBeforeDiscount = '';
	mappedOrderArticlesValue: ArticleGroup[] = [];
	constructor(
		private modalCtrl: ModalController,
		protected repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private pickerCtrl: PickerController,
		private translate: TranslateService,
		private router: Router,
		private analytics: AnalyticsService,
		private cdr: ChangeDetectorRef,
		private fb: FormBuilder
	) {
		super(repository);
		if (this.address && this.address.postalCode && this.address.postalCode.length > 0) {
			this.hadPostalCode = true;
		}
		if (this.order && this.order.preorder && this.order.preorder.postalCode && this.address.postalCode.length > 0) {
			this.hadPostalCode = true;
		}
	}
	// ngAfterViewInit(): void {
	// 	this.toOverview(); //TODO: to remove;
	// }

	static async show(modalCtrl: ModalController, analytics: AnalyticsService, order: Order, tip: number) {
		const modal = await modalCtrl.create({
			component: CheckoutModalComponent,
			componentProps: {
				tip,
			},
			showBackdrop: true,
			backdropDismiss: true,
			cssClass: AppComponent.largeScreen ? 'checkout-modal' : 'menu-modal',
		});
		await modal.present();
		analytics.beginCheckout(order);
		return await modal.onDidDismiss();
	}

	ngOnInit() {
		super.ngOnInit();
		this.analytics.checkoutProgress(this.order, null, 1);
		this.analytics.customerBeginsCheckout();
		this.createOrderForm();

		this.orderForm.valueChanges.subscribe(v => console.log(v));

		this.checkPrevOrder();

		this.totalPrice();
		this.mappedOrderArticlesValue = this.order.orderedArticles.map(it => {
			it = this.mapGroup(it);
			return it;
		});
		console.log('this.order', this.order);
	}

	onOrder() {
		super.onOrder();
		this.cdr.detectChanges();
		this.totalPrice();
	}

	checkPrevOrder() {
		if ((this.order && this.order.preorder) || this.repository._previousPreorder) {
			let knownData = this.order.preorder;

			if (this.repository._previousPreorder) {
				knownData = this.repository._previousPreorder;
			}

			let countryCode = countries.find(it => knownData?.phone?.trim().startsWith('+' + it.dialCode));
			const defaultPhone = {
				country: '+' + (countryCode?.dialCode || '41'),
				phone: knownData?.phone ? knownData?.phone?.trim()?.replace('+' + countryCode?.dialCode, '') : '',
			};

			if (knownData?.email && knownData.email.includes('@privaterelay.appleid.com')) {
				knownData.email = '';
			}

			if (this.repository._previousPreorder?.phone) {
				let defaultPhone = {
					country: '+49',
					phone: '',
				};

				if (this.repository && this.repository._previousPreorder?.phone) {
					let countryCode = countries.find(it => this.repository._previousPreorder?.phone?.trim().startsWith('+' + it.dialCode));
					defaultPhone = {
						country: countryCode?.dialCode ? '+' + countryCode?.dialCode : '+49',
						phone: this.repository._previousPreorder?.phone
							? this.repository._previousPreorder?.phone?.trim()?.replace('+' + countryCode?.dialCode, '')
							: '',
					};
				}
			}

			this.orderForm.patchValue(
				{
					name: knownData?.name?.split(/[ _]+/)[0] ?? '',
					surname: knownData?.name?.split(/[ _]+/)[1] ?? '',
					email: knownData?.email ?? '',
					phone: {
						country: defaultPhone.country,
						phone: defaultPhone.phone,
					},
					company: knownData?.companyName ?? '',
				},
				{
					emitEvent: true,
				}
			);
		}
	}

	onAddress() {
		super.onAddress();
		this.hadPostalCode = this.hadPostalCode || (this.address && this.address.postalCode && this.address.postalCode.length > 0);
	}

	onCustomer() {
		super.onCustomer();
		if (this.customer) {
			if (this.customer.postalCode && this.customer.postalCode.length > 0) {
				this.hadPostalCode = true;
			}
			if (!this.order.preorder.email) {
				this.order.preorder.email = this.customer.email;
			}
			if (!this.order.preorder.name) {
				this.order.preorder.name = this.customer.name;
			}
			if (!this.order.preorder.companyName) {
				this.order.preorder.companyName = this.customer.companyName;
			}
			if (!this.order.preorder.phone) {
				this.order.preorder.phone = this.customer.phone;
			}
			if (!this.order.preorder.floor) {
				this.order.preorder.floor = this.customer.floor;
			}
			if (!this.order.preorder.subcard) {
				this.order.preorder.subcard = this.customer.subcard;
			}
			if (this.order.preorder.type === PreorderType.DELIVERY) {
				if (!this.order.preorder.street) {
					this.order.preorder.street = this.customer.street;
				}
				if (!this.order.preorder.postalCode) {
					this.order.preorder.postalCode = this.customer.postalCode;
				}
				if (!this.order.preorder.city) {
					this.order.preorder.city = this.customer.city;
				}
				if (!this.order.preorder.number && this.order.preorder.street === this.customer.street) {
					this.order.preorder.number = this.customer.number;
				}
			}
		}
	}

	checkCustomer() {
		console.log(this.customer);
		if (this.customer) {
			if (this.customer?.name) {
				this.orderForm.patchValue({
					name: this.customer.name.split(' ')[0],
					surname: this.customer?.name.replace(this.customer.name.split(' ')[0], ''),
				});
			}
			if (this.customer?.email) {
				if (!this.customer?.email.includes('@privaterelay.appleid.com')) {
					this.orderForm.patchValue({
						email: this.customer?.email,
					});
				}
			}
			if (this.customer?.phone) {
				this.orderForm.patchValue({
					phone: {
						internationalNumber: this.customer?.phone ?? '',
						dialoCode: '+41',
						isoCode: 'de',
						nationalNumber: this.customer?.phone.trim().replace('+41', ''),
					},
				});
			}
		}
	}

	async close() {
		await this.updateForm();
		const data = {
			preorder: this.order.preorder,
			orderAt: this.order.orderAt,
			tip: this.tip,
			asap: this.order.asap,
		};
		this.repository.previousPreorder.emit(this.order.preorder);

		await this.modalCtrl.dismiss(data);
	}

	async updateForm() {
		this.order.preorder.name = this.getFormControlValue('name') + ' ' + this.getFormControlValue('surname');
		this.order.preorder.email = this.getFormControlValue('email');
		if (this.getFormControlValue('phone')) {
			this.order.preorder.phone = this.getFormControlValue('phone').country + this.getFormControlValue('phone').phone;
		}
		// Combine user's custom note with table number for kitchen
		const userNote = this.getFormControlValue('note') || '';
		const tableNumber = this.order?.tableNumber;
		let finalNote = userNote;

		const userNameForTableNumber = this.getFormControlValue('name');
		// add Name and Table number For QR Code Ordering
		if (tableNumber && tableNumber !== 'preorder_table') {
			finalNote = userNote ? `${userNote}\nTable: ${tableNumber},\n${userNameForTableNumber}` : `Table: ${tableNumber},\n${userNameForTableNumber}`;
		}
		// add For Preorder: Pick-Up Time and Name
		const formattedDate = moment(this.order.orderAt).format('HH:mm');
		if (tableNumber === 'preorder_table') {
			finalNote = userNote ? `${userNote}\n${formattedDate},\n${this.order.preorder.name }` : `${formattedDate},\n${this.order.preorder.name }`;
		}
		this.order.preorder.note = finalNote;
		this.repository.onOrderChange(this.order);
	}
	async dismiss() {
		await this.modalCtrl.dismiss();
	}

	async openTos() {
		window.open(TosPage.url, '_blank');
	}

	async openPrivacy() {
		window.open(PrivacyPage.url, '_blank');
	}

	slotToText(slot: Moment): string {
		const asapPossible = (OrderUtils.isInside(this.order) || OrderUtils.isTakeAway(this.order)) && this.isVenueOpen;
		if (!slot) {
			return this.translate.instant(asapPossible ? 'checkout_modal.first_slot' : 'checkout_modal.choose_slot');
		}
		const slotMoment = moment(slot);
		const sameDay = TimeUtils.isSameDate(slotMoment, moment());
		if (sameDay) {
			return slotMoment.format('HH:mm');
		} else {
			return slotMoment.format('DD.MM. HH:mm');
		}
	}

	onVenue() {
		this.isVenueOpen = isVenueOpen(this.venue);
	}

	onVenueError(error) {
		super.onVenueError(error);
		this.isVenueOpen = false;
		if (this.order) {
			this.order.asap = false;
		}
	}

	hiddenInCart(article: Article): boolean {
		return article.tags && article.tags.find(tag => tag.identifier === 'hide_cart') !== undefined;
	}
	reloadAddress() {
		if (this.order && this.order.preorder && this.address && this.order.preorder.type === PreorderType.DELIVERY && this.orderForm) {
			this.orderForm.patchValue({
				city: this.address?.city ?? '',
				street: this.address?.street ?? '',
				postalCode: this.address?.postalCode && this.address?.postalCode?.length > 0 ? this.address.postalCode : '',
				country: this.address?.country,
				number: this.address?.number,
			});
		}
	}
	async onButtonClick() {
		console.log(this.orderForm);
		console.log('onButtonClick()');
		this.orderForm.get('agb')!.markAsTouched();
		this.orderForm.get('name')!.markAsTouched();
		if (this.orderForm.get('agb')!.invalid || (this.orderForm.get('name')!.invalid && this.order?.tableNumber !== 'preorder_table')) {
			return;
		}

		if (this.order?.tableNumber === 'preorder_table') {
			this.markFormFieldsAsTouched(this.orderForm);
			if (!(this.orderForm.valid && this.orderForm?.get('phone')?.value?.phone)) {
				return;
			}
			if (!this.orderForm.valid) {
				return;
			}
		}
		await this.close();
	}

	markFormFieldsAsTouched(form: FormGroup) {
		Object.keys(form.controls).forEach(field => {
			const control = form.get(field);
			if (control instanceof FormControl) {
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.markFormFieldsAsTouched(control);
			}
		});
	}

	async toOverview() {
		// await this.slides.update();
		await this.slides.nativeElement.swiper.slideNext();
		console.log('Slide next');
		console.dir(this.slides.nativeElement);
		this.isOverviewPage = true;
	}
	async editPersonalData() {
		await this.slides.nativeElement.swiper.slidePrev();
		this.isOverviewPage = false;
	}
	slotSelected($event) {
		this.order.orderAt = $event;
		if (!$event) {
			this.order.asap = true;
		} else {
			this.order.asap = false;
		}
	}
	async backOrDismiss() {
		if (this.isOverviewPage) {
			await this.editPersonalData();
		} else {
			await this.dismiss();
		}
	}
	async loadSlots() {
		this.slots = [];
		this.order.orderAt = null;
		if (!this.venue) {
			this.snackbarCtrl.open(this.translate.instant('errors.venue'), null, {
				duration: 2000,
			});
			return;
		}

		if (this.order.preorder.type === PreorderType.FOOD_SPOT) {
			this.slots = [];
			this.order.orderAt = null;
			this.order.asap = true;
			return;
		}
		this.loading = true;

		try {
			const slots = (await getSlotsByOrder(this.venue, this.order)).map(slot => moment(slot.time));
			if (slots.length === 0) {
				this.loading = false;
				this.snackbarCtrl.open(this.translate.instant('checkout_modal.no_slots'), null, {
					duration: 2000,
				});
				return;
			}
			let isVenueOpenVar = true;
			try {
				isVenueOpenVar = isVenueOpen(this.venue);
			} catch (e) {}
			if (slots.length > 0) {
				if (isVenueOpenVar) {
					this.slots = [null, ...slots];
				} else {
					this.slots = [...slots];
				}
			}
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('checkout_modal.time_error'), null, {
				duration: 2000,
			});
			console.error(e);
		}
		this.loading = false;
	}
	priceOfOption(articleGroup: ArticleGroup, articleOption: ArticleOption): number {
		const price = getPrice(articleOption.article, OrderType.PREORDER, this.order.preorder.type);
		if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && articleGroup.isPromo) {
			return 0;
		}
		if (articleGroup) {
			const findGroup = articleGroup.article.groups.find(it => it._id === articleOption.group);
			if (findGroup) {
				if (findGroup.tags.find(it => it.identifier === 'half_pizza')) {
					return 0;
				}
			}
		}
		return price * articleOption.quantity;
	}
	createOrderForm() {
		const formControlNames: any = {};

		// validation changes for preorder_table
		if (this.order?.tableNumber !== 'preorder_table') {
			formControlNames[this.name] = ['', [Validators.required]];

			formControlNames[this.email] = [''];
		} else {
			formControlNames[this.name] = ['', [Validators.required]];
			formControlNames[this.surname] = ['', [Validators.required]];

			formControlNames[this.email] = [
				'',
				[
					Validators.required,
					Validators.pattern(
						"^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
					),
				],
			];
		}
		if (this.order.preorder.type === PreorderType.TAKE_AWAY) {
			formControlNames[this.phone] = this.fb.control('', [this._customRequiredPhone, this._customPhoneValidatorForLibrary]);
		}

		formControlNames[this.note] = [''];

		formControlNames[this.agb] = [false, [Validators.requiredTrue]];

		formControlNames[this.orderAt] = [''];
		this.orderForm = this.fb.group(formControlNames);

		this.checkCustomer();
		this.reloadAddress();
	}

	private _customRequiredPhone(control: AbstractControl) {
		if (!control.value?.phone) {
			return { required: true };
		}

		return null;
	}

	private _customPhoneValidatorForLibrary(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}
		if (String(control.value?.phone).length === 1) {
			return { invalidPhone: true };
		}
		const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();

		try {
			const phoneNumber = phoneUtil.parse(control?.value?.country + control?.value?.phone.toString());
			if (phoneUtil.isValidNumber(phoneNumber) && phoneUtil.isPossibleNumber(phoneNumber)) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	getFormControlValue(controlName?: string) {
		if (controlName) {
			return this.orderForm.get(controlName)?.value;
		}
		return '';
	}
	isValid(controlName?: string): boolean {
		if (controlName) {
			return this.orderForm?.get(controlName)?.hasError('required') && this.orderForm?.get(controlName)?.touched;
		}
		return this.orderForm?.invalid;
	}

	isValidByPattern(controlName?: string): boolean {
		if (controlName) {
			return this.orderForm?.get(controlName)?.errors && !this.orderForm?.get(controlName)?.hasError('required');
		}
		return this.orderForm.invalid;
	}

	getErrorsForm(controlName) {
		if (controlName) {
			return this.orderForm.get(controlName).errors;
		}

		return null;
	}

	private _customPhoneValidator(control: AbstractControl) {
		const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
		try {
			const phoneNumber = phoneUtil.parse(control?.value);
			if (phoneUtil.isValidNumber(phoneNumber) && phoneUtil.isPossibleNumber(phoneNumber)) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	handleChangeRadio(event: { detail: { value: string } }) {
		console.log(event.detail.value);
	}
	async totalPrice() {
		// Ensure asap is set correctly for qr orders
		this.order.asap = this.order.asap || !this.order.orderAt;

		console.log('BEFORE MAP', this.order, this.venue);
		this.totalPriceValue = numberToCurrency(
			OrderUtils.orderTotalPrice(this.order, true, true, this.repository.companyCode$.getValue() ?? null) + this.tip,
			this.order.currency
		);

		const resultOfTaxes = await this.calculateTaxes(this.order);
		const totalSumBeforeDiscount = OrderUtils.orderTotalPrice(this.order, false, false) + this.tip - resultOfTaxes;
		this.totalPriceBeforeDiscount = numberToCurrency(totalSumBeforeDiscount >= 0 ? totalSumBeforeDiscount : 0, this.order?.currency);
		if (!this.companyDisount) {
			const code = this.repository.companyCode$.getValue();
			console.log(code);
			if (code && code.storeDiscount) {
				this.companyDisount = (Number(code.storeDiscount) * 100).toString() + '%';
			}
		}
	}

	private async calculateTaxes(order: Order) {
		if (order.orderedArticles.length <= 0) {
			return 0;
		}
		if (this.calculateTaxesLoading) {
			return 0;
		}
		this.calculateTaxesLoading = true;
		let result = 0;
		const copyOfOrder = JSON.parse(JSON.stringify(order)) as Order;
		try {
			copyOfOrder.userUid = this.customer?.uid ?? '';
			copyOfOrder.preorder.name = 'calculate taxes';
			copyOfOrder.preorder.email = 'dnd@smoothr.de';
			copyOfOrder.preorder.number = '+49234234324';
			const response = (await Api.calculateTaxes(copyOfOrder)).data;
			if (response?.totalPrice && response?.totalNetPrice) {
				result = Number(response.totalPrice) - Number(response.totalNetPrice);
			}
			this.calculateTaxesLoading = false;

			return Math.round(result * 100) / 100;
		} catch (e) {
			console.log('CATCH ERROR', e);
			this.calculateTaxesLoading = false;
			return result;
		}
	}
	changeTip(tip: number) {
		this.tip = tip;
		this.totalPrice();
	}

	checkPriceArticle(articleGroup: ArticleGroup, orderType: OrderType, preorderType: PreorderType) {}
	mapGroup(articleGroup: ArticleGroup) {
		if (!this.venue || !this.order) {
			return articleGroup;
		}
		if (this.venue) {
			const foundArticle = this.venue.articleCategories
				.map(it => {
					if (it.visible) {
						const foundArticle = it.articles.find(ar => ar._id === articleGroup.article._id);

						return foundArticle ?? null;
					} else {
						return null;
					}
				})
				.filter(it => !!it);
			if (foundArticle.length === 1) {
				const test = JSON.parse(JSON.stringify(articleGroup)) as ArticleGroup;
				test.article = JSON.parse(JSON.stringify(foundArticle[0]));

				return test;
			}
			return articleGroup;
		}
		return articleGroup;
	}
	public async changeTime() {
		console.log('changeTime');
		if (this.order?.tableNumber !== 'preorder_table') {
			return;
		}
		const result = await BeforeCreateOrderSelectTimeDialogComponent.show(
			this.modalCtrl,
			this.order,
			this.venue,
			this.order.preorder.type
		);
		console.log('RESULT', result);
		// if (result?.asap) {
		// 	this.order.asap = true;
		// 	this.order.orderAt = null;
		// }
		if (result?.slot) {
			this.order.asap = false;
			this.order.orderAt = result.slot;
		}
		this.repository.onOrderChange(this.order);
	}
	public formatTime(order: Order) {
		if (order.orderAt) {
			return moment(order.orderAt).format('HH:mm');
		} else {
			return 'Today';
		}
	}
	public formatYear(order: Order) {
		if (order.orderAt) {
			return moment(order.orderAt).locale(this.translate.currentLang.toLocaleLowerCase()).format('dddd Do MMMM');
		} else {
			return moment().locale(this.translate.currentLang.toLocaleLowerCase()).format('dddd Do MMMM');
		}
	}
	public async onNextButton() {
		console.log('onNextButton()');
		this.updateForm();
		if (this.orderForm.invalid) {
			this.orderForm.markAllAsTouched();
			return;
		}
		this.orderForm.get('agb')!.markAsTouched();

		if (!this.isOverviewPage) {
			if (this.orderForm.get('agb')!.value) {
				await this.toOverview();
			}
		} else {
			await this.close();
		}
	}
	isFormValid() {
		if (this.order.preorder.type === PreorderType.FOOD_SPOT) {
			return this.orderForm?.valid && this.orderForm?.get('phone')?.value?.phone;
		}
		return this.orderForm?.valid && this.orderForm?.get('phone')?.value?.phone;
	}
	updateAgb() {
		this.orderForm.patchValue({
			agb: !this.orderForm.getRawValue().agb,
		});
	}

	async loadGiftCard() {
		try {
			const result = await AddGiftCardDialogComponent.show(this.modalCtrl, this.venue, this.order);
			if (result?.giftCard) {
				this.order.giftCard = result?.giftCard;
				this.repository.onOrderChange(this.order);
			} else {
				if (result?.order) {
					this.repository.onOrderChange(result.order);
				}
			}
		} catch (e) {}
	}

	onPhoneBlur() {
		this.orderForm.get(this.phone).markAsTouched();
	}
}
